// extracted by mini-css-extract-plugin
module.exports = {"article":"style-module--article--25w10","title":"style-module--title--7AdrJ"};